import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_3 = { class: "header_wrapper" }
const _hoisted_4 = { style: {"width":"70px","margin-left":"auto"} }
const _hoisted_5 = { class: "d-flex justify-center mb-5" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = {
  style: {"width":"50%"},
  class: "pr-1"
}
const _hoisted_9 = {
  style: {"width":"50%"},
  class: "pr-1"
}
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = {
  style: {"width":"50%"},
  class: "pr-1"
}
const _hoisted_12 = {
  style: {"width":"50%"},
  class: "pr-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isProcessingVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[10] || (_cache[10] = [
          _createElementVNode("div", { class: "modal-content" }, [
            _createElementVNode("p", null, "処理中です。しばらくお待ちください..."),
            _createElementVNode("div", { class: "spinner" })
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_toolbar, {
        color: "primary",
        dark: "",
        style: {"position":"relative"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _ctx.routerBack,
            icon: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_toolbar_title, {
            style: {"position":"absolute","left":"50%","transform":"translateX(-50%)","margin":"0","padding":"0","max-width":"70%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"},
            class: "text-center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.lastName + _ctx.firstName), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_btn, {
              onClick: _ctx.putChildren,
              loading: _ctx.btnLoading,
              variant: "text",
              class: "no-background-hover font-weight-bold",
              icon: ""
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode(" 保存 ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick", "loading"])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_form, {
      ref: "put_children_form",
      class: "px-2 py-3"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("div", {
            class: "picked_img",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.pickFile && _ctx.pickFile(...args)))
          }, [
            _createElementVNode("img", {
              src: _ctx.pickedImg ?? undefined
            }, null, 8, _hoisted_6)
          ], 512), [
            [_vShow, _ctx.pickedImg]
          ]),
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(["file_uploader pa-3", [{'-drag': _ctx.isDrag == 'new'}]]),
            for: "corporation_file",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.pickFile && _ctx.pickFile(...args))),
            onDragover: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.checkDrag($event, 'new', true)), ["prevent"])),
            onDragleave: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.checkDrag($event, 'new', false)), ["prevent"])),
            onDrop: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)), ["prevent"]))
          }, [
            _createElementVNode("input", {
              class: "d-none",
              id: "file-input",
              ref: "fileInput",
              type: "file",
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args))),
              accept: ".png,.jpg,image/jpeg,image/png"
            }, null, 544)
          ], 34), [
            [_vShow, !_ctx.pickedImg]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[13] || (_cache[13] = _createElementVNode("p", { class: "body-2 blue-grey--text" }, "姓", -1)),
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.lastName,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.lastName) = $event)),
              variant: "outlined",
              class: "large-text-field",
              rules: [_ctx.rules.required]
            }, null, 8, ["modelValue", "rules"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[14] || (_cache[14] = _createElementVNode("p", { class: "body-2 blue-grey--text" }, "名", -1)),
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.firstName,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.firstName) = $event)),
              variant: "outlined",
              class: "large-text-field",
              rules: [_ctx.rules.required]
            }, null, 8, ["modelValue", "rules"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[15] || (_cache[15] = _createElementVNode("p", { class: "body-2 blue-grey--text" }, "セイ", -1)),
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.lastNameKana,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.lastNameKana) = $event)),
              rules: [_ctx.rules.typeKanaFullWidth],
              variant: "outlined",
              class: "large-text-field"
            }, null, 8, ["modelValue", "rules"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[16] || (_cache[16] = _createElementVNode("p", { class: "body-2 blue-grey--text" }, "メイ", -1)),
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.firstNameKana,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.firstNameKana) = $event)),
              rules: [_ctx.rules.typeKanaFullWidth],
              variant: "outlined",
              class: "large-text-field"
            }, null, 8, ["modelValue", "rules"])
          ])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}